import { render, staticRenderFns } from "./StacHeader.vue?vue&type=template&id=e9cfbf72&scoped=true"
import script from "./StacHeader.vue?vue&type=script&lang=js"
export * from "./StacHeader.vue?vue&type=script&lang=js"
import style0 from "./StacHeader.vue?vue&type=style&index=0&id=e9cfbf72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9cfbf72",
  null
  
)

export default component.exports